"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireDefault(require("react"));

var _BaseInput = _interopRequireDefault(require("./BaseInput"));

var _MaskedInput = _interopRequireDefault(require("./MaskedInput"));

var _style = require("./style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * Styled BaseWeb input. See https://baseweb.design/components/input/
 */
const Input = props => {
  const {
    className = '',
    onChange,
    overrides,
    ...inputProps
  } = props;
  const InputComponent = (0, _isUndefined.default)(props.format) ? _BaseInput.default : _MaskedInput.default;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(InputComponent, _extends({
    overrides: {
      Root: {
        style: _style.getRootStyle
      },
      Input: {
        style: _style.getInputStyle
      },
      InputContainer: {
        style: _style.getInputContainerStyle
      },
      EndEnhancer: {
        style: _style.getEnhancerStyle
      },
      StartEnhancer: {
        style: _style.getEnhancerStyle
      },
      ...(overrides || {})
    },
    onChange: onChange
  }, inputProps)));
};

var _default = Input;
exports.default = _default;